import { userService } from 'services'

export function authHeader () {
  // return authorization header with jwt token
  const userData = userService.get()
  if (userData && userData.access_token) {
    return {
      'Authorization': `Bearer ${userData.access_token}`,
      'X-Signature-Token': userData.signature,
    }
  } 
  return {}
}
